import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from "../../grid/grid.base.case";
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { BaseCase } from '../../../basecase';
declare var app;

@Component({
  selector: 'app-a2-store-receive',
  templateUrl: './a2-store-receive.component.html',
  styleUrls: ['./a2-store-receive.component.scss']
})
export class A2StoreReceiveComponent extends GridBaseCase {
  //dataArrayList: Array<any> = [];
  searchValue:string = null;//搜索字段
  pageName:string = null;
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { super(); 
    let that = this;
    that.pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
        }
      })
    }
  }
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  loadingchileData(data) {
    const that = this;
    //that.dataArrayList = data;
  }

  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      this.LoadData(1);
    }
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.ListData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const date = localStorage.getItem('PlanMakingListDate');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = {"a_FK_SystemUser_ID":that.com.GetAccount.Id,"s_OpType":"ADD"}
    if(that.searchValue){
      body.RequestBody["a_Name"] = that.com.LikeSearch(that.searchValue.trim());
    }
    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
    };
    that.com.SaveSearchInfo(_searchObj);

    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {


      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.ListData = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.baseService.ListData.push(objfield);
          // console.log(that.baseService.ListData);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.ListData.length) {
          that.infiniteScroll.disabled = true;
        } else {
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  EventLink(ev, item) {
    // console.log(item);
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
    this.dataindex(this.baseService.ListData);
  }
  /**
   * 获取选中的数据源
   */
  dataindex(dataArray: Array<any>) {
    const that = this;
    let objarray: Array<any> = [];
    dataArray.forEach((items, index) => {
      if (items.isCheck) {
        objarray.push(items);
      }
    });
    that.baseService.arrayData = objarray;
  }


  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g,"/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }
}
